import React from 'react';

import { isChunkLoadError } from './lazy-with-reload';

interface Props extends React.PropsWithChildren {}

interface State {
  error: unknown;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  state: Readonly<State> = {
    error: null,
  };

  componentDidCatch(error: any, info: any) {
    console.error(error, 'componentDidCatch', info);
  }

  render() {
    if (this.state.error) {
      const stale = isChunkLoadError(this.state.error);
      return (
        <div
          role="alert"
          style={{
            maxWidth: 480,
            margin: '64px auto',
            padding: '0 16px',
            fontFamily: 'sans-serif',
            lineHeight: 1.5,
          }}
        >
          <p style={{ fontSize: 18, fontWeight: 600, margin: '0 0 8px' }}>
            {stale
              ? 'A newer version of the app is available.'
              : 'Something went wrong showing this page.'}
          </p>
          <p style={{ margin: '0 0 16px' }}>
            {stale
              ? 'Reload to load the latest version.'
              : 'Reload to try again. If it keeps happening, tell us which page you were on.'}
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }

    return <>{this.props.children}</>;
  }
}
